module.exports = function() {
  return new Worker(__webpack_public_path__ + "7bf7a15c6deff30c4857.worker.js");
};